<template>
<div class='stephen-von-worley-data-chart'>
  <div v-if='hasData && displayCirclesChart' class='stephen-von-worley-data-chart__data'>
    <joined-circles-chart
      v-for='(data, index) in formatDataForCirclesChart'
      :key='`joined-circles-chart-${index}`'
      :data='data.data'
      :label='data.label'
      :indexing-key='index'
      />
  </div>
  <div v-if='hasData' class='stephen-von-worley-data-chart__summary'>
    <diverging-stacked-bar-chart
      v-if='displayBarChart'
      :data='formatDataForBarChart'
    />
  </div>
  <div class='stephen-von-worley-data-chart__no-data' v-if='!hasData'>
    <div>
      <lottie-animation
        :key="isDarkMode ? 'dark' : 'light'"
        ref="anim"
        :animationData="noDataAnimation"
        :loop="true"
        :style="'height: 250px; background-color: transparent'"
      />
    </div>
    <div class='stephen-von-worley-data-chart__no-data__text'>
      <div class='stephen-von-worley-data-chart__no-data__text__title'>{{$t('complience.stats.no.data')}}</div>
      <div class='stephen-von-worley-data-chart__no-data__text__subtitle'>{{$t('complience.stats.no.data.subtitle')}}</div>
    </div>
  </div>
</div>
</template>
<script>

import JoinedCirclesChart from '@/components/charts/JoinedCirclesChart.vue';
import DivergingStackedBarChart from '@/components/charts/DivergingStackedBarChart.vue';
import LottieAnimation from 'lottie-web-vue';
import { mapGetters } from 'vuex';
import noDataLight from '@/assets/icons/animations/no-data.json';
import noDataDark from '@/assets/icons/animations/no-data-dark.json';

export default {
  name: 'StephenVonWorleyDataChart',
  components: { LottieAnimation, DivergingStackedBarChart, JoinedCirclesChart },
  props: {
    stats: {
      type: Object,
      required: true,
    },
    formatDataForCirclesChart: {
      type: Array,
      required: true,
    },
    formatDataForBarChart: {
      type: Array,
      required: true,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    visiblePopup() {
      if (!this.visiblePopup) {
        this.displayBarChart = false;
        this.displayCirclesChart = false;
      } else {
        this.displayBarChart = true;
        this.displayCirclesChart = true;
      }
    },
  },
  mounted() {
    if (!this.visiblePopup) {
      this.displayBarChart = false;
      this.displayCirclesChart = false;
    } else {
      this.displayBarChart = true;
      this.displayCirclesChart = true;
    }
  },
  data() {
    return {
      displayBarChart: false,
      displayCirclesChart: false,
    };
  },
  computed: {
    ...mapGetters('theme', ['isDarkMode']),
    hasData() {
      return Object.keys(this.stats).length > 0;
    },
    noDataAnimation() {
      return this.isDarkMode ? noDataDark : noDataLight;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.stephen-von-worley-data-chart {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: row;

  &__data {
  }

  &__summary {
    margin-left: rem(20);
  }

  &__no-data {
    display: flex;
    flex-direction: row;
    flex-basis: 100%;

    &__text {
      display: flex;
      flex-direction: column;
      margin-left: 12%;
      margin-top: rem(100);

      &__title {
        font-family: $font-family-bold;
        font-size: rem(30);
        color: var(--text-secondary);
        display: flex;
        justify-content: center;
      }

      &__subtitle {
        font-family: $font-family-semibold;
        font-size: rem(20);
        color: var(--text-secondary);
        justify-content: center;
      }
    }
  }
}
</style>
